module.exports = __webpack_public_path__ + "static/juliet-Normal-02fa22f7296464ecfeca31a1c5a077f6.jpg";